import React, { useEffect } from 'react'
import { useBlogsHook } from '../useBlogsHook'
import { Button, InputLabel, MenuItem, Select, TextField, Checkbox } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import { useRecipesHook } from '../../../Hooks/communicators/useRecipesHook';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function AddNewBlog() {
    const {
        blogTitle1,
        setBlogTitle1,
        blogDescription1,
        setBlogDescription1,
        blogImage1,
        setBlogImage1,
        blogTitle2,
        setBlogTitle2,
        blogDescription2,
        setBlogDescription2,
        blogImage2,
        setBlogImage2,
        blogTitle3,
        setBlogTitle3,
        blogDescription3,
        setBlogDescription3,
        blogImage3,
        setBlogImage3,
        blogTrimester,
        setBlogTrimester,
        blogRecipeReferences,
        setBlogRecipeReferences,
        blogRelatedData,
        setBlogRelatedData,
        dropdownOptions,
        addNewBlog,
        blogsLoading,
        handleFileChange1,
        handleFileChange2,
        handleFileChange3,
        file,
        uploading,
        progress,
        setFile,
        setUploading,
        blogTags,
        setBlogTags,
    } = useBlogsHook();
    const { globalTags } = useSelector((state: any) => state.tags.value);
    const { fetchTags } = useTagsHook();
    
    // Recipe hook'ları
    const { fetchAllRecipes } = useRecipesHook();
    const { allRecipes } = useSelector((state: any) => state.recipe.value);
    
    // Quill editor configuration
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'list', 'bullet', 'indent',
        'align', 'link', 'image'
    ];
    
    useEffect(() => {
        fetchAllRecipes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className='flex justify-start items-center flex-col'>
            <h1 className='text-2xl font-bold my-8'>
                Add New Blog
            </h1>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Title - 1
            </InputLabel>
            <TextField
                label='Blog Title - 1'
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="text"
                placeholder='Blog Title - 1'
                value={blogTitle1}
                onChange={(e) => setBlogTitle1(e.target.value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Content - 1
            </InputLabel>
            <div style={{ width: '450px', marginTop: '16px', marginBottom: '70px' }}>
                <ReactQuill
                    theme="snow"
                    value={blogDescription1}
                    onChange={setBlogDescription1}
                    modules={modules}
                    formats={formats}
                    style={{
                        height: '250px',
                    }}
                    placeholder="Write blog content here..."
                />
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Image - 1
            </InputLabel>
            <TextField
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="file"
                // value={blogImage}
                onChange={handleFileChange1}
            />
            <div>
                {
                    uploading === true
                        ? <p>Uploading...</p>
                        : null
                }
                {
                    uploading === true && progress !== 0
                        ? <p>{progress}%</p>
                        : null
                }
            </div>
            {
                blogImage1 !== ''
                    ?
                    <div>
                        <LazyLoadImage
                            src={blogImage1}
                            alt="Uploaded Blog Image 1"
                            effect="blur"
                            style={{ width: '450px', height: 'auto', borderRadius: '8px' }}
                        />
                    </div>
                    : null
            }
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Title - 2
            </InputLabel>
            <TextField
                label='Blog Title - 2'
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="text"
                placeholder='Blog Title - 2'
                value={blogTitle2}
                onChange={(e) => setBlogTitle2(e.target.value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Content - 2
            </InputLabel>
            <div style={{ width: '450px', marginTop: '16px', marginBottom: '70px' }}>
                <ReactQuill
                    theme="snow"
                    value={blogDescription2}
                    onChange={setBlogDescription2}
                    modules={modules}
                    formats={formats}
                    style={{
                        height: '250px',
                    }}
                    placeholder="Write blog content here..."
                />
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Image - 2
            </InputLabel>
            <TextField
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="file"
                // value={blogImage}
                onChange={handleFileChange2}
            />
            <div>
                {
                    uploading === true
                        ? <p>Uploading...</p>
                        : null
                }
                {
                    uploading === true && progress !== 0
                        ? <p>{progress}%</p>
                        : null
                }
            </div>
            {
                blogImage2 !== ''
                    ?
                    <div>
                        <LazyLoadImage
                            src={blogImage2}
                            alt="Uploaded Blog Image 2"
                            effect="blur"
                            style={{ width: '450px', height: 'auto', borderRadius: '8px' }}
                        />
                    </div>
                    : null
            }
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Title - 3
            </InputLabel>
            <TextField
                label='Blog Title - 3'
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="text"
                placeholder='Blog Title - 3'
                value={blogTitle3}
                onChange={(e) => setBlogTitle3(e.target.value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Content - 3
            </InputLabel>
            <div style={{ width: '450px', marginTop: '16px', marginBottom: '70px' }}>
                <ReactQuill
                    theme="snow"
                    value={blogDescription3}
                    onChange={setBlogDescription3}
                    modules={modules}
                    formats={formats}
                    style={{
                        height: '250px',
                    }}
                    placeholder="Write blog content here..."
                />
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Image - 3
            </InputLabel>
            <TextField
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="file"
                // value={blogImage}
                onChange={handleFileChange3}
            />
            <div>
                {
                    uploading === true
                        ? <p>Uploading...</p>
                        : null
                }
                {
                    uploading === true && progress !== 0
                        ? <p>{progress}%</p>
                        : null
                }
            </div>
            {
                blogImage3 !== ''
                    ?
                    <div>
                        <LazyLoadImage
                            src={blogImage3}
                            alt="Uploaded Blog Image 3"
                            effect="blur"
                            style={{ width: '450px', height: 'auto', borderRadius: '8px' }}
                        />
                    </div>
                    : null
            }
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Tags
            </InputLabel>
            <Select
                multiple
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                value={blogTags}
                label="Blog Tags"
                onChange={(e: any) => setBlogTags(e.target.value)}>
                {
                    globalTags.map((option: any) => {
                        return (
                            <MenuItem value={option}>{option}</MenuItem>
                        )
                    })
                }
            </Select>
            <Button
                onClick={() => fetchTags()}
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                variant='contained'
                color='primary'>
                Fetch Tags Manually (If not updated)
            </Button>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Blog Trimester
            </InputLabel>
            <Select
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                value={blogTrimester}
                label="Trimester"
                onChange={(e: any) => setBlogTrimester(e.target.value)}>
                {
                    dropdownOptions.map((option: any) => {
                        return (
                            <MenuItem value={option.value}>{option.label}</MenuItem>
                        )
                    })
                }
            </Select>
            
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Related Recipes
            </InputLabel>
            <Select
                multiple
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                value={(blogRelatedData as any[]).map((item: any) => item.recipeId)}
                displayEmpty
                label="Select Recipe"
                renderValue={(selected) => {
                    if ((selected as string[]).length === 0) {
                        return <em>Select Recipe</em>;
                    }
                    return `${(selected as string[]).length} recipe selected`;
                }}
                onChange={(e: any) => {
                    const selectedIds = e.target.value as string[];
                    const newRelatedData: any[] = [];
                    
                    selectedIds.forEach(recipeId => {
                        const selectedRecipe = allRecipes.find((recipe: any) => recipe._id === recipeId);
                        if (selectedRecipe) {
                            newRelatedData.push({
                                recipeId: selectedRecipe._id,
                                recipeName: selectedRecipe.recipeName,
                                recipeImage: selectedRecipe.recipeImage
                            });
                        }
                    });
                    
                    setBlogRelatedData(newRelatedData);
                }}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 400,
                            width: 450,
                        },
                    },
                }}>
                {
                    allRecipes && allRecipes
                        .filter((recipe: any) => !recipe.isDeleted) // Silinmiş tarifleri gösterme
                        .map((recipe: any) => {
                            const isSelected = (blogRelatedData as any[]).some((item: any) => item.recipeId === recipe._id);
                            return (
                                <MenuItem key={recipe._id} value={recipe._id}>
                                    <Checkbox
                                        checked={isSelected}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center',
                                        width: '100%'
                                    }}>
                                        <LazyLoadImage
                                            src={recipe.recipeImage} 
                                            alt={recipe.recipeName}
                                            effect="blur"
                                            placeholderSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Crect width='32' height='32' fill='%23f0f0f0'/%3E%3C/svg%3E"
                                            style={{
                                                width: '32px',
                                                height: '32px',
                                                objectFit: 'cover',
                                                borderRadius: '4px',
                                                marginRight: '12px',
                                                border: '1px solid #ddd'
                                            }}
                                        />
                                        <div style={{ flex: 1 }}>
                                            <div style={{ 
                                                fontSize: '14px',
                                                fontWeight: isSelected ? '600' : '500',
                                                color: isSelected ? '#1976d2' : 'inherit'
                                            }}>
                                                {recipe.recipeName}
                                            </div>
                                            <div style={{ 
                                                fontSize: '12px', 
                                                color: '#666',
                                                marginTop: '2px'
                                            }}>
                                                {recipe.recipeType} • Trimester {recipe.recipeTrimester}
                                            </div>
                                        </div>
                                    </div>
                                </MenuItem>
                            );
                        })
                }
            </Select>
            
            {/* Selected recipes display */}
            {blogRelatedData && (blogRelatedData as any[]).length > 0 && (
                <div style={{ width: '450px', marginBottom: '16px' }}>
                    <InputLabel
                        style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: 'black',
                            marginBottom: '8px'
                        }}>
                        Selected Recipes ({(blogRelatedData as any[]).length})
                    </InputLabel>
                    {(blogRelatedData as any[]).map((recipe: any, index: number) => (
                        <div 
                            key={recipe.recipeId}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '12px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                marginBottom: '12px',
                                backgroundColor: '#f9f9f9',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}
                        >
                            <LazyLoadImage
                                src={recipe.recipeImage} 
                                alt={recipe.recipeName}
                                effect="blur"
                                placeholderSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Crect width='60' height='60' fill='%23f0f0f0'/%3E%3C/svg%3E"
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                    marginRight: '16px',
                                    border: '2px solid #e0e0e0'
                                }}
                            />
                            <div style={{ flex: 1 }}>
                                <div style={{ 
                                    fontSize: '16px', 
                                    fontWeight: '600',
                                    color: '#333',
                                    marginBottom: '4px'
                                }}>
                                    {recipe.recipeName}
                                </div>
                                <div style={{ 
                                    fontSize: '12px', 
                                    color: '#666',
                                    fontStyle: 'italic'
                                }}>
                                    ID: {recipe.recipeId}
                                </div>
                            </div>
                            <Button
                                size="small"
                                color="error"
                                variant="outlined"
                                onClick={() => {
                                    const updatedRelatedData = (blogRelatedData as any[]).filter((_: any, i: number) => i !== index);
                                    setBlogRelatedData(updatedRelatedData);
                                }}
                                style={{
                                    minWidth: '70px',
                                    fontSize: '12px'
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    ))}
                </div>
            )}
            
            {
                blogsLoading === true
                    ? <Button
                        onClick={() => { }}
                        disabled
                        style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                        variant='contained'
                        color='primary'>
                        Adding...
                    </Button>
                    : <Button
                        onClick={addNewBlog}
                        disabled={blogTitle1 === '' || blogDescription1 === '' || blogImage1 === '' || blogTrimester === ''}
                        style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                        variant='contained'
                        color='primary'>
                        Add Blog
                    </Button>
            }

        </div>
    )
}
